<template>
  <div class="chart-wrapper" style="max-width: 800px; margin: 0 auto">
    <template v-if="!loading">
      <PollResultLine
        :chociecount="chociecount"
        :poll="poll"
        :polllabelarray="labels"
        :polldata="polldata"
      />
    </template>
  </div>
</template>

<script>
  import PollResultLine from '~/components/presentations/PollResultLine.vue';

  export default {
    props: {
      poll: {
        type: Object,
        required: true,
      },
    },
    components: {
      PollResultLine,
    },
    mounted() {
      this.loadComputedProperties().then((this.loading = false));
    },

    data: function () {
      return {
        loading: true,
        labels: [],
        polldata: [],
        chociecount: null,
      };
    },
    methods: {
      loadComputedProperties() {
        var _this = this;
        return new Promise(function (resolve, reject) {
          if (_this.getPollData()) {
            resolve();
          } else {
            reject('error');
          }
        });
      },
      getPollData() {
        this.labels = this.poll.poll_choices.map(function (choice) {
          return choice.choice;
        });
        this.polldata = this.poll.poll_choices.map(function (choice) {
          return choice.poll_answers.length;
        });
        this.chociecount = this.poll.poll_choices.length;
        return true;
      },
    },
  };
</script>
